'use strict';

import log from 'fancy-log';
import pluginError from 'plugin-error';
import through2 from 'through2';
import * as util from '../utilities';
import * as jsonMerge from './json-merge';

const PLUGIN_NAME = 'gulp-merge-json-in-folders';

interface Options {
    /**
     * source path of current folder for 'strings.json'
     */
    src: string;
}

function gulpMergeJsonInFolders(options: Options) {
    // override options settings if not specified.
    options = Object.assign({ src: './src/assets/strings' }, options || {});

    const externalSources: string[] = [];

    return through2.obj(
        /**
         * Transform
         */
        function (file, encoding, callback) {
            if (file.isDirectory()) {
                externalSources.push(file.path);
            }

            callback();
        },

        /**
         * Flush
         */
        function (callback) {
            try {
                const merge = new jsonMerge.JsonMerge();
                const files = merge.mergeJsonInFolders(options.src, externalSources);

                files.forEach(file => this.push(file));
            } catch (e) {
                const error = (!e.plugin || (e.plugin !== PLUGIN_NAME)) ?
                    util.extendError(new pluginError({ plugin: PLUGIN_NAME, message: e.message }), e) : e;
                log.error(error);
            }

            callback();
        });
}

module.exports = gulpMergeJsonInFolders;
